import Component from '../app/component'
import Player from "@vimeo/player";


export default class MosaiqgroupComponent extends Component {
  constructor (el) {
    super(el)
    this.data = {}
  }

  init () {

    const videoContainer = this.el.querySelector('.cm-mosaiqgroup-video__video')

    if (videoContainer) {
      const player = new Player(videoContainer, {
        id: videoContainer.dataset.id,
        background: false,
        autoplay: false,
        muted: false,
        loop: false,
        dnt: true,
        fullscreen: true
      })

      const thumb = videoContainer.querySelector('.cm-mosaiqgroup-video__thumb')
      if (thumb) {
        player.ready().then(() => thumb.remove())
      }
    }
  }
}
